import {
    Farm,
    farmSchema,
} from 'app/agriculture/contexts/RequiredStartupProviders/FarmContext/farmSchema';
import { createAxiosInstance } from 'app/agriculture/queries/createAxiosInstance';

export async function getFarm({ queryKey: [endpoint] }: { queryKey: [endpoint: string] }) {
    const instance = createAxiosInstance();
    const { data } = await instance.get<unknown>(endpoint);

    return farmSchema.parse(data) as Farm;
}
